import { createApi } from '@reduxjs/toolkit/query/react';

import type {
  BehandlingerResponse,
  BehandlingsstederResponse,
  HentBehandlingLenkerResponseV2,
  SokBehandlingerResponse,
  VentetiderForBehandlingResponse,
  VentetiderForBehandlingsstedResponse,
} from '../../types/Helsenorge.VelgBehandlingssted.Libraries.EntitiesEntities';

import type { Suggestion } from '@helsenorge/autosuggest/components/autosuggest';
import { createFetchBaseQuery } from '@helsenorge/framework-utils/hn-proxy-service-redux';

export const velgBehandlingsstedApi = createApi({
  reducerPath: 'velgBehandlingsstedApi',
  baseQuery: createFetchBaseQuery('velgbehandlingssted'),
  endpoints: builder => ({
    getBehandlinger: builder.query<BehandlingerResponse, void>({
      query: () => ({ url: 'api/v1/Behandlinger' }),
    }),
    getBehandlingssteder: builder.query<BehandlingsstederResponse, void>({
      query: () => ({ url: 'api/v1/Behandlingssteder' }),
    }),
    getSokBehandlinger: builder.query<SokBehandlingerResponse, void>({
      query: () => ({ url: 'api/v1/SokBehandlinger' }),
    }),
    getSokBehandlingerSuggestions: builder.query<Suggestion[], void>({
      query: () => ({ url: `api/v1/SokBehandlinger` }),
      transformResponse: (response?: SokBehandlingerResponse): Suggestion[] =>
        response?.behandlinger?.map(item => ({
          label: item.navn ?? '',
          value: item.behandlingsId ?? '',
          optionalLabel: item.synonym ? `${item.synonym}` : '',
        })) ?? [],
    }),
    getVentetiderForBehandling: builder.query<VentetiderForBehandlingResponse, string>({
      query: bid => ({
        url: 'api/v1/VentetiderForBehandling',
        params: { behandlingId: bid },
      }),
    }),
    getVentetiderForBehandlingssted: builder.query<VentetiderForBehandlingsstedResponse, string>({
      query: orgnr => ({
        url: 'api/v1/VentetiderForBehandlingssted',
        params: { behandlingsstedId: parseInt(orgnr) },
      }),
    }),
    getBehandlingLenke: builder.query<HentBehandlingLenkerResponseV2, { behandlingId: string; orgNr: number }>({
      query: ({ behandlingId, orgNr }) => ({
        url: 'api/v2/BehandlingLenke',
        params: { behandlingId, orgNr },
      }),
    }),
  }),
});

export const {
  useGetBehandlingerQuery,
  useGetBehandlingsstederQuery,
  useGetSokBehandlingerQuery,
  useGetSokBehandlingerSuggestionsQuery,
  useGetVentetiderForBehandlingQuery,
  useGetVentetiderForBehandlingsstedQuery,
  useGetBehandlingLenkeQuery,
} = velgBehandlingsstedApi;
